import { Box, Grid, Typography } from "@mui/material";
import { useUserContext } from "context/userContext";
import React from "react";
import FilterCard from "./FilterCard";

const FiltersList = ({
  paginatedData,
  quantity,
  handleQuantityChange,
  handleAddToCart
}) => {
  const { isAuth } = useUserContext();
  return (
     <Grid container spacing={3} mt={0} mb={2}>
      {paginatedData.length > 0 ? (
        paginatedData.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <FilterCard
              isGuest={!isAuth}
              item={item}
              quantity={quantity}
              handleQuantityChange={handleQuantityChange}
              handleAddToCart={handleAddToCart}
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Box textAlign="center">
            <Typography variant="h6">Ingen data fundet</Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default FiltersList;
